import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../service/http.service';

@Injectable({
  providedIn: 'root'
})
export class TierService {

  constructor(private httpService: HttpService) { }
  getTierList(params: any): Observable<any> {
    return this.httpService.get('tier', params);
  }

  saveTier(data: any): Observable<any> {
    return this.httpService.post('tier/save-tier', data);
  }
  getTier(data: any): Observable<any> {
    return this.httpService.post('tier/get-data', data);
  }
  
}
